export default __webpack_public_path__ + "static/media/marbletheory.c7f2f6ca.mp4";